import { z } from 'zod';
import { BATTALION_APPOINTMENTS, type BattalionAppointment } from '../constants/appointments.js';
import { publicUserSchema } from './auth.js';

/**
 * CO-only "assign 2IC / Adjt / QM" request. `null` clears the holder.
 * The user being targeted must be an active OFFICER — that gate lives in the
 * service so the schema only validates shape.
 */
export const assignAppointmentRequestSchema = z.object({
  appointment: z.enum(BATTALION_APPOINTMENTS).nullable(),
});
export type AssignAppointmentRequest = z.infer<typeof assignAppointmentRequestSchema>;

/**
 * Snapshot of who currently holds each appointment. Keys are always present;
 * a NULL value means the appointment is vacant.
 */
export const appointmentHoldersSchema = z.object({
  '2IC': publicUserSchema.nullable(),
  ADJT: publicUserSchema.nullable(),
  QM: publicUserSchema.nullable(),
});
export type AppointmentHolders = z.infer<typeof appointmentHoldersSchema>;

export type { BattalionAppointment };
